import * as yup from 'yup';

export const schema: any = yup.object().shape({
  topic: yup.string().nullable().required('Please choose a topic.'),
  name: yup.string().trim().nullable().required('The Name field is required.'),
  email: yup
    .string()
    .trim()
    .nullable()
    .required('The Email field is required.')
    .email('Enter a valid email address.'),
  message: yup
    .string()
    .trim()
    .nullable()
    .required('The Message field is required.')
    .min(10, 'Please add a little more detail (at least 10 characters).'),
  // honeypot — no validation; must never block a real submission
  website: yup.string().nullable(),
});
